import React from 'react';

import { RadioGroupContextProps } from './RadioGroup.types';

const RadioGroupContext = React.createContext<RadioGroupContextProps | undefined>(undefined);

export default RadioGroupContext;
